<div class="container-fluid background-level2 px-0">
  <header>
    <div class="header-develop">
      <div class="container">
        <div class="row pt-4 align-items-center text-start">
          <p (click)="goBack()" class="back px-0 my-1 pb-0 ms-2">
            <img class="back-icon" src="/assets/img/dh-landing/back.png" alt="" />
            {{ 'back:button:levels' | translate }}
          </p>
        </div>
        <div class="row pt-2 align-items-center flex-column text-center">
          <h1 class="title col-12 col-md-7 my-3">
            Level 2: Sensationality
          </h1>
        </div>
        <div class="row my-4 justify-content-center text-center">
          <p class="description col-12 col-md-8 mb-4">
            This is the introduction page for the Level 2 questionnaire.
            Content coming soon &mdash; individual layout will be provided later.
          </p>
        </div>

        <div class="row justify-content-center gap-5">
          <button class="btn btn-level2 col-auto" (click)="getFormLevel2()">
            <span style="color: #fff">{{ 'take:free:questionaire' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </header>

  <div class="d-flex justify-content-center px-0">
    <div class="col-11 col-md-9 card-generic my-5">
      <div class="row justify-content-between">
        <div class="col-sm-9 col-12">
          <p class="title-card">About Level 2: Sensationality</p>
          <p class="description-card">
            Placeholder description for the Level 2 questionnaire. The final
            copy and design will be provided in a later iteration.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center mt-4">
    <div class="col-11 col-md-6 card-generic my-3">
      <div class="row">
        <p class="title-card text-center">Ready to start?</p>
        <p class="description-card text-center">
          Take the Level 2 questionnaire and get your profile.
        </p>
      </div>
      <div class="row justify-content-center mt-3">
        <button (click)="getFormLevel2()" class="btn btn-level2 col-auto">
          <span style="color: #fff">{{ 'take:free:questionaire' | translate }}</span>
        </button>
      </div>
    </div>
  </div>

  <div class="container-footer">
    <div class="footer-container">
      <div class="d-flex pt-5 align-items-center flex-column text-center">
        <h2 class="footer-title col-12 col-md-7 my-4">
          {{ 'footer:landing' | translate }}
        </h2>
        <p class="footer-landing col-12 col-md-9 mb-5 mt-4">
          {{ 'description:footer:landing' | translate }}
        </p>
        <a
          class="btn mt-5 btn-footer col-auto"
          target="__blank"
          href="https://doublehealix.com/het-double-healix-model/"
        >
          {{ 'button:learn:model' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
